import {
  EmploymentType,
  PropertyViewingStatus,
  ResidencePermit,
} from "@justhome/api-core";
import { getAlpha2Codes, getName, registerLocale } from "i18n-iso-countries";
import deLocale from "i18n-iso-countries/langs/de.json";
import enLocale from "i18n-iso-countries/langs/en.json";

registerLocale(enLocale);
registerLocale(deLocale);

export const euCountries = [
  "AT",
  "BE",
  "BG",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "ES",
  "FI",
  "FR",
  "GR",
  "HR",
  "HU",
  "IE",
  "IT",
  "LT",
  "LU",
  "LV",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SE",
  "SI",
  "SK",
];

const euCountriesSet = new Set(euCountries);
export const isEUCountry = (country: string) => euCountriesSet.has(country);

export const countryOptions = (locale: string): Map<string, string> => {
  const options = countrySelectOptions(locale);
  return new Map(options.map((option) => [option.value, option.label]));
};

export const countrySelectOptions = (
  locale: string,
): { value: string; label: string }[] => {
  const germanyCode = "DE";

  return Object.keys(getAlpha2Codes())
    .map((code) => ({
      value: code,
      label: getName(code, locale) || "",
    }))
    .sort((a, b) => {
      if (a.value === germanyCode) {
        return -1;
      }
      if (b.value === germanyCode) {
        return 1;
      }
      if (isEUCountry(a.value) && !isEUCountry(b.value)) {
        return -1;
      }
      if (!isEUCountry(a.value) && isEUCountry(b.value)) {
        return 1;
      }
      return a.label.localeCompare(b.label);
    });
};

export const propertyViewedStatusTypes = [
  "NOT_VIEWED",
  "VIEWING_SCHEDULED",
  "VIEWED",
  "RESERVED",
] as const satisfies PropertyViewingStatus[];

export const residencePermits = [
  "VISA",
  "TEMPORARY",
  "PERMANENT",
  "EU_LONG_TERM",
  "BLUE_CARD",
] as const satisfies ResidencePermit[];

export const employmentTypes = [
  "EMPLOYED",
  "SELF_EMPLOYED",
  "RETIRED",
  "CIVIL_SERVANT",
  "FREELANCER",
  "UNEMPLOYED",
] as const satisfies EmploymentType[];

export const yes = "YES";
export const no = "NO";
export type YesNo = typeof yes | typeof no;
export const yesNoOptions = [yes, no] as const satisfies YesNo[];
